import Nav from "./nav"
import Slider from "./slider"
import ContactForm from "./contact-form"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Slider(jQuery)
    ContactForm(jQuery)
})
